import React from 'react';
import { useLocation } from 'react-router-dom'; // Use useLocation to access passed data
import './approvalmainpage.css'; // Import the CSS file
import ExpenseApprovalPage from './Approvalretrival'; // Import the ExpenseApprovalPage component
import ExpenseTracker from './Expensetracking'; // Import the ExpenseTracker component
import FormAside from './FormAside';

function Approvalmainpage() {
  // Use useLocation to access the state passed from the FormPage or other components
  const location = useLocation();
  const { empId, empName, designation } = location.state || {};

  return (
    <div className="approval-main-container ">
      <FormAside />
      {/* Render employee details */}
      {/* <div className="employee-details">
        <div><strong>Employee ID:</strong> {empId}</div>
        <div><strong>Employee Name:</strong> {empName}</div>
        <div><strong>Designation:</strong> {designation}</div>
      </div> */}

      {/* Render the two pages side by side */}
      <div className="pages-container mainBlock">
        <div className="page">
          <ExpenseTracker /> {/* Render ExpenseTracker */}
        </div>
        <div className="page">
          <ExpenseApprovalPage /> 
          {/* Render ExpenseApprovalPage */}
        </div>
      </div>
    </div>
  );
}

export default Approvalmainpage;
